import script from "./accordionMenu.vue?vue&type=script&lang=js"
export * from "./accordionMenu.vue?vue&type=script&lang=js"

import "./accordionMenu.vue?vue&type=style&index=0&id=54c2e141&lang=css"

const __exports__ = script;

export default __exports__